import script from "./hpointsDeduc.vue?vue&type=script&setup=true&lang=js"
export * from "./hpointsDeduc.vue?vue&type=script&setup=true&lang=js"

import "./hpointsDeduc.vue?vue&type=style&index=0&id=7033c13c&lang=scss"

const __exports__ = script;

export default __exports__